module.exports = __webpack_public_path__ + "resources/images/laptop-b36b5b000c2822fc8b0e7fa55bf8f8aa-cache.png";